GP.GPMod('PremiumViewer',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;

    var _data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            _data.premium_collection = new self.app.collections.Premium();
        },
        premium_collection: null
    };

    this.gallery = {};

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_viewer", events.setup_viewer);
            vent.on(self.moduleName+":modal_direction", events.modal_direction);

            vent.on(self.moduleName+":show_content", events.show_content);
            vent.on(self.moduleName+":update_video_thumb", events.update_video_thumb);

            GP.reqres.setHandler(self.moduleName+":get_collection", function() {
                return _data.premium_collection;
            });
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
        },
        setup_viewer: function() {
            self.gallery.is_gallery = false;
            var _gallery_pages = ['/user/profile', '/premium/media'];
            _.each(_gallery_pages, function(page) {
                if (window.location.pathname.indexOf(page) != -1) {
                    self.gallery.is_gallery = true;
                }
            });

            if (typeof(premium_viewer_content) !== 'undefined' && premium_viewer_content) {
                var premium_model = new GP.models.Premium(premium_viewer_content);
                _data.premium_collection.reset();

                // add rest of collection from profile if available and if we have access to view (owner or purchased)
                if (_util.check_location('/user/profile')) {
                    var profile_collection = null;
                    if (premium_viewer_content.tags.indexOf('PRIVATE') !== -1) {
                        profile_collection = GP.reqres.request('Premium:get_private_collection');
                    } else {
                        // update model url in profile_collection with premium_model url from the php module.
                        // this is needed so the purchased content url is available when using prev/next buttons. 
                        vent.trigger('Premium:update_content_collection', premium_model);
                        profile_collection = GP.reqres.request('Premium:get_collection');
                    }

                    if (profile_collection && profile_collection.length) {
                        profile_collection.each(function(model) {
                            if (model.get('duid') == GP.sdata.my_user.duid || model.get('purchased')) {
                                _data.premium_collection.add(model);
                            }
                        });
                    }
                }

                if (_util.check_location('/premium/media') && typeof my_library !== 'undefined' && my_library) {
                    var library_tab = GP.reqres.request('Premium:get_library_tab');

                    if (library_tab == 'purchased' && typeof my_library !== 'undefined' && my_library) {
                        _data.premium_collection.add(my_library);
                    } else if (library_tab == 'premium' && typeof my_premium_library !== 'undefined' && my_premium_library) {
                        _data.premium_collection.add(my_premium_library);
                    } else if (library_tab == 'private' && typeof my_private_library !== 'undefined' && my_private_library) {
                        _data.premium_collection.add(my_private_library);
                    }
                }

                events.show_viewer(premium_model);
            }
        },
        show_viewer: function(premium_model) {
            var layout = new self.app.views.PremiumViewerLayout({
                id: 'premium-viewer',
                model: premium_model
            });

            $("#premium-viewer-region").append(layout.el);
            layout.render();
        },
        modal_direction: function(current_id, direction) {
            var _premium_model = _data.premium_collection.find(function(model) {
                return model.get('premium_content_id') == current_id;
            });

            var index = _data.premium_collection.indexOf(_premium_model);

            if (direction == 'next') {
                events.modal_next(index);
            } else {
                events.modal_prev(index);
            }
        },
        modal_prev: function(current_index) {
            let new_index = (current_index == 0) ? _data.premium_collection.length - 1 : current_index - 1;
            events.show_viewer(_data.premium_collection.at(new_index));
        },
        modal_next: function(current_index) {
            let new_index = (current_index == _data.premium_collection.length - 1) ? 0 : current_index + 1;
            events.show_viewer(_data.premium_collection.at(new_index));
        },
        // adding a separate one for now (most likely can be combined with trigger/show viewer)
        show_content: function(premium_content_id, duid) {
            vent.trigger('Modal:open', {
                url: _util.clean_url('/members/premium/viewer/'),
                premium_content_id: premium_content_id,
                duid: duid
            });
        },
        update_video_thumb: function(model) {
            var video = document.getElementById('video_player_html5_api');
            var time_index = video.currentTime;
            if (time_index) {
                vent.trigger('Premium:update_video_thumb', model, time_index);
            }
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
    });
});
